import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { deleteCallBlocking } from '../../../apiclients/streamsapi_bridge';
import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";

const DeleteCallBlocking = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();

    async function removeThisRow(e) {
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        //alert(props.rowUniq);
        let deleteNum = await deleteCallBlocking(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            props.rowUniq
        );

        let saverep = await deleteNum.json();
        if (saverep.status && saverep.status == "success") {
            props.setSuccessMessage(saverep.message);
            props.deleteRowFlag(true);
            props.onClose();
        } else {

        }
    }
    return (
        <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{props.isWhiteList ? t("deletewhitelistNumbers") : t("deleteclacklistNumbers")}</span>
            </div>


            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeThisRow(e)}>
                    {t("Delete")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisRow(e)}>Delete</MDBBtn>
            </MDBModalFooter> */}
        </>
    )
});

export default DeleteCallBlocking;
